export const refreshTokenName = 'refresh_token';
export const scope = 'bbraunSharedDataAccessSecurity';
